import React, { lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import NotFound from "../components/404/NotFound";
import StyleTemplate from "../templates/StyleTemplate";

const Menu = lazy(() => import("../components/menu/Menu"));
const Learn = lazy(() => import("../components/learn/Learn"));
const Navigation = lazy(() => import("../components/navigation/Navigation"));

const App = () => (
  <StyleTemplate>
    <BrowserRouter>
      <Suspense fallback={<></>}>
      <Route component={Navigation} />
      <Switch>
        <Route path="/" exact component={Menu} />
        <Route path="/chapter/:id" component={Learn} />
        <Route path="*" component={NotFound} />
      </Switch>
      </Suspense>
    </BrowserRouter>
  </StyleTemplate>
);

export default App;
